import { Grid, styled } from "@mui/material";

export const StyledGrid = styled(Grid)({
  marginBottom: "1rem",
  ".MuiTypography-root": {
    lineHeight: "2.5rem",
  },
});
